import { IDocument } from 'app/services/documents';
import { DownloadIcon, PaperClipIcon } from 'assets/icons';
import Spinner from 'Components/Spinner';
import { useContext, useState } from 'react';
import { MessageContext } from '..';

export interface MessageAttachementsProps {
  documents: IDocument[];
  className?: string;
}

export default function MessageAttachements({
  documents,
  className,
}: MessageAttachementsProps) {
  const { theme } = useContext(MessageContext);

  const [isLoading, setIsLoading] = useState<{ [id: string]: boolean }>({});

  if (!documents) return <></>;

  const downloadDocument = (doc: IDocument) => {
    setIsLoading({ ...isLoading, [doc.id]: true });

    fetch(`${process.env.REACT_APP_URL}${doc.file_url}`, {
      method: 'GET',
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', doc.title);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoading({ ...isLoading, [doc.id]: false });
      });
  };

  return (
    <div className={className}>
      {documents.map((doc) => (
        <div
          key={doc.id}
          onClick={() => downloadDocument(doc)}
          className={`py-3 md-max:py-2 my-1 px-6 items-center ${theme.bgLight} rounded-2xl md-max:rounded-xl shadow-sm text-xs text-gray-dark font-semibold cursor-pointer flex`}
        >
          <PaperClipIcon className="w-5 h-5 md-max:w-3 md-max:h-3" />
          <div className="flex-1 ml-2">{doc.title}</div>

          {isLoading[doc.id] && <Spinner bounce={false} />}
          {!isLoading[doc.id] && <DownloadIcon />}
        </div>
      ))}
    </div>
  );
}
